// extracted by mini-css-extract-plugin
export default {"Title":"ConfirmationModal_Title__2dGwV"};